
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-unit-8-enrichment-test-batch",
      function () {
        return require("private-next-pages/tnpsc-unit-8-enrichment-test-batch/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-unit-8-enrichment-test-batch"])
      });
    }
  